export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10684.80e3bca6.jpg";